import _Cascader from "antd/es/cascader";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _Form from "antd/es/form";
import React, { Component } from 'react';
import CascaderChoice from '../../common/Question/Cascader';
import { getLocalText } from '@/utilities/language';
import IconFont from '@/components/common/IconFont';
var FormItem = _Form.Item;
var LocChoicePC = /*#__PURE__*/function (_Component) {
  _inherits(LocChoicePC, _Component);
  function LocChoicePC() {
    _classCallCheck(this, LocChoicePC);
    return _possibleConstructorReturn(this, _getPrototypeOf(LocChoicePC).apply(this, arguments));
  }
  _createClass(LocChoicePC, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        question = _this$props.question;
      return React.createElement(CascaderChoice, this.props, function (_ref) {
        var error = _ref.error,
          formAnswer = _ref.formAnswer,
          _onChange = _ref.onChange,
          options = _ref.options,
          titles = _ref.titles;
        var titleStr = titles.map(function (e) {
          return e.title;
        }).filter(function (e) {
          return e;
        }).join('/');
        return React.createElement(FormItem, {
          label: label,
          validateStatus: error ? 'error' : null,
          hasFeedback: true,
          help: error,
          required: question.required
        }, React.createElement(_Cascader, {
          showSearch: true,
          allowClear: false,
          value: formAnswer.selected_values,
          placeholder: getLocalText('mobile.selected').concat(titleStr ? ": ".concat(titleStr) : ''),
          onChange: function onChange(choice) {
            return _onChange(choice);
          },
          options: options,
          suffixIcon: React.createElement("span", {
            style: {
              fontSize: 12
            }
          }, React.createElement(IconFont, {
            type: "icon-zhankai"
          }))
        }));
      });
    }
  }]);
  return LocChoicePC;
}(Component);
export { LocChoicePC as default };